import { Injectable, OnDestroy } from '@angular/core';
import { RxMethods } from '../../services/rxjs.service';

@Injectable()
export class FileUploadService implements OnDestroy {
    url: string;
    configs: object = {
        acceptedFormats: [],
        hideProgressBar: false,
        hideResetBtn: false,
        hideSelectBtn: false,
        multiple: false
    }
    scope: any;
    onUploadComplete = this.rxMethod.createSubjectService();

    constructor(private rxMethod: RxMethods) {
    }

    ngOnDestroy(): void {
        this.onUploadComplete.unsubscribe();
    }
}